import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { login, saveTokenInLocalStorage } from "../slice/clientAuth";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";
import Cookies from "js-cookie";

import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

const ClientSignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

 useEffect(() => {
  const savedEmail = Cookies.get("c_email");
  const savedPassword = Cookies.get("c_password");

  if (savedEmail && savedPassword) {
    setFormData({
      email: savedEmail,
      password: savedPassword,
    });

    const checkbox = document.getElementById("rememberMe");
    if (checkbox) checkbox.checked = true;
  }
}, []);


  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleGoogleLogin = async (googleUser) => {
    try {
      const res = await dispatch(login({ email: googleUser.email, name: googleUser.name, googleId: googleUser.sub }));
  
      if (res.meta.requestStatus === "fulfilled") {
        const { access_token, expires_in, client } = res.payload;
  
        saveTokenInLocalStorage(access_token, expires_in);
        localStorage.setItem("user_id", JSON.stringify(client.id));
        localStorage.setItem("user_name", client.first_name);
  
        toast.success("Google Login successful!");
        navigate("/panel/info");
      } else {
        toast.error("Google login failed on server.");
      }
    } catch (err) {
      toast.error("Google login error.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = formData;
    const rememberMe = document.getElementById("rememberMe").checked;

    const result = await dispatch(login(formData));

    if (result.meta.requestStatus === "fulfilled") {
      const { access_token, expires_in, client } = result.payload;

      saveTokenInLocalStorage(access_token, expires_in);
      localStorage.setItem("user_id", JSON.stringify(client.id));
      localStorage.setItem("user_name", client.first_name);

      // Set or remove cookie based on rememberMe
      if (rememberMe) {
        Cookies.set("c_email", email, { expires: 30 }); // 30 days
        Cookies.set("c_password", password, { expires: 30 }); // 30 days
      } else {
        Cookies.remove("c_email");
        Cookies.remove("c_password");
      }

      toast.success("Login successful!", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });

      navigate("/panel/info");
    } else {
      toast.error("Login failed. Please check your credentials.", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };

  return (
    // <div className="container mt-5" style={{ maxWidth: "400px" }}>
    //   <h2 className="mb-4 text-center">Client Login</h2>
    //   <form onSubmit={handleSubmit}>
    //     <div className="mb-3">
    //       <label className="form-label">Email</label>
    //       <input
    //         type="email"
    //         name="email"
    //         required
    //         value={formData.email}
    //         onChange={handleChange}
    //         className="form-control"
    //         placeholder="Enter your email"
    //       />
    //     </div>
    //     <div className="mb-3">
    //       <label className="form-label">Password</label>
    //       <input
    //         type="password"
    //         name="password"
    //         required
    //         value={formData.password}
    //         onChange={handleChange}
    //         className="form-control"
    //         placeholder="Enter your password"
    //       />
    //     </div>
    //     <button type="submit" className="btn btn-primary w-100"
    //     >
    //       Sign In
    //     </button>
    //   </form>
    //   <div className="text-center mt-3">
    //     Don't have an account?{" "}
    //     <Link to="/signup">Sign Up</Link>
    //   </div>
    // </div>
    <>
      <ClientHeader />
      <main className="overflow-hidden">
              <section className="homepad-signin">  
                <div className="container">
                  <div className="row">
                    {/* 👶 Register Section */}
                    <div className="col-md-6 left-panel-signin"
                        style={{
                          backgroundImage: "url('/assets/images/login-left.jpg')",
                          backgroundRepeat: "no-repeat"
                        }}>
                      <div className="left-overlay-signin">
                        <h2 className="montserrat font-weight-bold lh-1 font-size-60">Welcome, <span className="text-yellow">Parents</span> & <span className="text-yellow">Caregivers</span></h2>
                        <div className="">
                        <p className="m-0 font-size-14 lh-base">You are your child’s most powerful advocate—and you don’t have to navigate this journey alone. At The Just Generation Foundation, we’re here to help you recognize your child’s unique needs early and connect with trusted professionals who can guide you forward. Whether you're facing speech delays, behavioral concerns, or just a gut feeling that something isn’t quite right, our tools, referrals, and support resources are designed with you in mind. Because every child deserves the best start—and every parent deserves the right support. <br />
                                        🔵 Explore our screening tools, service providers, and family resources today.</p>
                        </div>
                        {/* <div className="d-flex align-items-center mt-3">
                          <img src="https://randomuser.me/api/portraits/women/44.jpg" className="rounded-circle me-2" width="40" height="40" />
                          <div>
                            <div><strong className="montserrat font-weight-bold">Devon Lane</strong></div>
                            <small>Co-Founder, Design.co</small>
                          </div>
                        </div> */}
                      </div>
                    </div>
      
                    {/* 🔐 Login Section */}
                    <div className="col-md-6 bg-white d-flex align-items-center">
                      <div className="login-form w-100">
                        <div className="logo text-center mb-4">
                          <img src="/assets/images/logo-login.png" className="img-fluid" />
                        </div>
                        <h3 className="font-weight-bold montserrat text-primary font-size-38 mb-3 lh-1 text-center">Welcome back ! Login</h3>
                        <p className="text-center text-dark">Lorem Ipsum is simply dummy text of the printing!</p>
      
                        <form className="mt-3 mt-xl-4 pt-xl-2 d-block" onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <label className="form-label text-primary mb-1 font-weight-semibold">Mobile Number or Email Address</label>
                            <input
                              type="text"
                              name="email"
                              className="form-control"
                              placeholder="Enter your email or mobile number"
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label text-primary mb-1 font-weight-semibold">Password</label>
                            <input
                              type="password"
                              name="password"
                              className="form-control"
                              placeholder="Enter your password"
                              value={formData.password}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="text-primary font-weight-semibold">
                              <input type="checkbox" id="rememberMe" className="me-1" />
                              <label htmlFor="rememberMe">  Remember Password</label>
                            </div>
                            <a href="/forgot-password" className="text-decoration-none text-primary font-weight-semibold"><u>Forgot Password?</u></a>
                          </div>
                          <div className="pt-2 pt-xl-3">
                            <button className="btn btn-yellow w-100 mb-3 font-weight-bold font-size-18"><span className="d-block py-1">Login</span></button>
                          </div>
                          <div className="text-center">
                            <p className="mb-3 font-weight-medium font-size-16">Don’t have an account? <Link to="/signup" className="text-decoration-none text-yellow font-weight-semibold"><u>Sign Up</u></Link></p>
                            <div className="social-icons d-flex justify-content-center">
<GoogleLogin
  onSuccess={(credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);
    console.log("Google user:", decoded);

    // You can now send the token or email to your backend
    // Or use directly if you're doing token-based session
    handleGoogleLogin(decoded);
  }}
  onError={() => {
    toast.error("Google Sign-In failed");
  }}
/>

                        {/* <a href="#" className="text-decoration-none mx-2"><img src="/assets/images/iphone-icon.svg" className="img-fluid" alt="Apple" /></a> */}
                        {/* <a href="#" className="text-decoration-none"><img src="/assets/images/facebookicon.svg" className="img-fluid" alt="Facebook" /></a> */}
                      </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <ClientFooter />
            </main>
    </>
  );
};

export default ClientSignIn;
